import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "99Taxis Clone App",
  titlePart2: "Development Company",
  description: "Leading experts in creating scalable, secure, and fully customizable taxi booking apps tailored for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "99Taxis Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why is",
  titlePart2: "99Taxis Clone App",
  titlePart3: "Superlative For Taxi Booking Businesses?",
  description1: "In Brazil’s fast-evolving mobility landscape, urban commuters prioritize convenience, affordability, and trust. That’s where the 99Taxis Clone App by Mobility Infotech comes in—a transformative solution purpose-built for Brazil’s booming ride-hailing industry. Whether you’re a solo entrepreneur launching a new service or a fleet owner looking to go digital, our 99Taxis Clone App is engineered to match Brazil’s unique market needs. From real-time ride requests to in-app chat, automated fare calculations, and multiple local payment integrations like Pix and Boleto, our platform ensures a reliable and intuitive experience for both riders and drivers.",
  description2: "What sets us apart isn’t just functionality—it’s the business edge you gain. From Portuguese language support to flexible promo campaigns, surge pricing, and region-specific ride types, this app is your gateway to growing your taxi business in São Paulo, Rio, Brasília, and beyond. With built-in scalability, you can grow effortlessly—from one city to the entire country. In a competitive space like Brazil’s, you need more than just an app—you need a strategy. Choose Mobility Infotech’s 99Taxis Clone App: built smart, built fast, built to scale.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Powering Canada’s transportation evolution—one ride at a time.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch instant ride-hailing services with smart dispatch, GPS tracking, and secure Pix/Boleto/Credit Card payments. Ideal for startups aiming to replicate 99Taxis’ efficiency across Brazilian metros.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Support Brazil’s sustainability goals with shared rides, fare splitting, and route optimization—perfect for São Paulo and Rio’s eco-conscious commuters.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Manage company transportation with invoice-ready billing, employee usage logs, and admin-level controls—ideal for HR departments in Brazil’s growing business hubs.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Enable intercity or hourly bookings with flexible pricing models—ideal for tourists and business travellers in Brazil’s major cities.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Serve high-end clients with premium vehicle booking, chauffeur options, and real-time status updates—great for hotels, events, and executive fleets.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Tap into Brazil’s dense urban zones with fast and affordable two-wheeler rides for last-mile connectivity.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Go to market with a completely branded solution—logo, colors, and local features included—for a quick and tailored launch across Brazil.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Offer stress-free airport travel with flight tracking, advanced booking, and real-time driver alerts—ideal for airports like GRU, GIG, and CNF.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Support Brazil’s green transition by enabling EV rides, charging point integration, and low-emission routes.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Meet Brazil’s accessibility regulations with wheelchair-ready vehicles, driver assistance features, and user-friendly accessible ride booking.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with Brazil’s",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our next-gen taxi app solutions and watch your business accelerate like never before.",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs Across the Board",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Overall Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Increase in Customer Loyalty and Repeat Usage",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Each Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch a 99Taxis-like app? Understanding the operational flow is essential. Here's a streamlined look at how our 99Taxis Clone App works to ensure seamless service and user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, we integrate the most advanced technologies into your 99Taxis Clone taxi app to ensure an exceptional user experience, greater security, and efficient fleet operations. Here’s a look at the key innovations we bring:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "Real-time traffic-aware route suggestions for faster travel across congested Brazilian cities.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "Live vehicle health status, trip tracking, and driver behavior data make fleet management smarter.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "Automated customer service in Portuguese, handling bookings, support tickets, and feedback 24/7.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Tamper-proof and transparent payment logs with blockchain-powered transactions via Pix and cards.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Passengers are auto-matched with drivers based on ratings, proximity, and previous history.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Augmented Reality directions help drivers navigate tricky Brazilian streets with better accuracy.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of Our",
  titlePart2: "99Taxis Clone Taxi App",
  titlePart3: "Development",
  description: "Partner with Mobility Infotech to create a robust, scalable, and future-ready 99Taxis-like taxi app tailored for the Brazilian market.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "Offer passengers a user-friendly and seamless taxi booking experience that’s smart, safe, and tailored for everyday urban commuting in Brazil.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Instant ride requests with a localized Portuguese interface."
      },
      {
        title: "Multiple Payment Options",
        desc: "Accept Pix, Boleto, card payments, and even cash."
      },
      {
        title: "Ride Sharing Availability",
        desc: "Riders can share trip status for added safety."
      },
      {
        title: "Schedule a Ride",
        desc: "Book ahead for airport or intercity rides."
      },
      {
        title: "Live Driver Tracking",
        desc: "Follow your ride on the map in real time."
      },
      {
        title: "Push Notifications",
        desc: "Get instant ride updates and promos in-app."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Equip your drivers with smart tools for real-time navigation, effortless communication, and complete visibility of their performance and income.",
    boxes: [
      {
        title: "Direct Calling",
        desc: "Drivers can call passengers directly via the app."
      },
      {
        title: "Optimized Route Navigation",
        desc: "Live street view and fastest routes in real-time."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "One-tap tracking for ride status and timing."
      },
      {
        title: "Built-In Help & Support",
        desc: "In-app support for FAQs, maps, and tech help."
      },
      {
        title: "Earnings Dashboard",
        desc: "Real-time income summaries and payment logs."
      },
      {
        title: "In-App Chat",
        desc: "Secure rider-driver communication without phone numbers."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "Manage your operations like a pro with a real-time control center that lets you oversee dispatch, drivers, bookings, and routes across cities.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Auto-match passengers to nearest available drivers."
      },
      {
        title: "Booking Management",
        desc: "Manage all bookings from one central dashboard."
      },
      {
        title: "Live Fleet Tracking",
        desc: "Watch your cars and drivers live across cities."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send urgent updates to drivers or groups."
      },
      {
        title: "Complete Transaction History",
        desc: "View ride logs, fares, driver history, and more."
      },
      {
        title: "Smart Route Planning",
        desc: "Optimise for cost savings and better ETAs."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Gain full control of your taxi business with a powerful backend system designed to oversee operations, track revenue, and scale with confidence.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: " Add, remove, or assign drivers based on demand."
      },
      {
        title: "In-Depth Analytics",
        desc: "Track business performance, heatmaps, and revenue."
      },
      {
        title: "Integrated Payment Management",
        desc: "Monitor transactions across Pix, Boleto, and cards."
      },
      {
        title: "Promo & Loyalty Management",
        desc: " Launch Brazil-specific discounts and referral programs."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Coordinate in real time with drivers and dispatchers."
      },
      {
        title: "Booking Oversight",
        desc: "Full control over booking history, edits, and approvals."
      },
    ]
  },
}

const customData = {
  titlePart1: "Serving Diverse Industries",
  titlePart2: "with Custom Taxi App Solutions",
  description: "Whether you're a taxi fleet owner, a travel operator, or a large corporation, we provide scalable, feature-rich taxi booking apps to enhance customer experiences and streamline operations.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Simplify employee commute logistics with live tracking, shift-based ride management, and detailed reports for smart corporate travel.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Scale your taxi operations with dynamic ride matching, driver insights, and automated payments for a future-ready fleet.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "Coordinate large-scale events effortlessly with intelligent scheduling, guest ride updates, and real-time tracking to deliver a premium attendee experience.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Ensure student safety with end-to-end route visibility, real-time tracking, and instant notifications to parents and administrators.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Craft unforgettable journeys with flexible route planning, live vehicle tracking, and seamless coordination between drivers and tour groups.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "A taxi app’s revenue goes beyond just completing rides. Here’s how our 99Taxis Clone App solutions by Mobility Infotech can deliver a high ROI for your business in Brazil:",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Earn per ride as a flat rate or flexible percentage.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Apply higher fares during heavy traffic or events like Carnaval.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Reports and Analytics",
      desc: "Upsell premium vehicles or executive cars with priority booking fees.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Offset ride losses with cancellation penalties.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Offer vehicles on lease or franchise model for driver partners.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Sell in-app ad space for local businesses or brands.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over a decade of experience and the latest technology, Mobility Infotech helps you launch a fully customised 99Taxis Clone App tailored for the Brazilian market.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "All the core tech, fully rebranded to your business identity.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Launch your app in less than 3 days.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Expand across Brazil—city by city or nationwide.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Integrate easily with Brazil-specific payment gateways, CRM, and ERP.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "From UI/UX to backend features—customize it all.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Portuguese-first design, built for local comfort.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "Partner with Mobility Infotech to build your ideal 99Taxis Clone App and reach your business goals with these features:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch from the admin panel.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "Track drivers in real time with GPS.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations anytime with live dashboards.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Access detailed reports and analytics to optimize service.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Offer multiple secure payment options.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Enable customers to rate trips and provide instant feedback.",
    },
  ],
}

const globalData = {
  titlePart1: "Proven Impact from",
  titlePart2: "Our Taxi App Development",
  titlePart3: "solutions",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is Mobility Infotech’s 99Taxis Clone App?",
    answer: "It’s a white-label taxi booking app replicating the success of 99Taxis, customized for Brazil.",
  },
  {
    id: "1",
    question: "02. Why should I choose Mobility Infotech for my taxi app development?",
    answer: "We bring 10+ years of global expertise, rapid deployment, and end-to-end localised features.",
  },
  {
    id: "2",
    question: "03. How customizable is the 99Taxis Clone App developed by Mobility Infotech?",
    answer: "Every part—from vehicle type and pricing model to design and payment options—is customizable.",
  },
  {
    id: "3",
    question: "04. Does Mobility Infotech provide post-launch support and maintenance?",
    answer: "Yes, 24/7 support, regular updates, and real-time issue resolution are part of our offering.",
  },
  {
    id: "4",
    question: "05. How quickly can Mobility Infotech deploy the 99Taxis Clone App?",
    answer: "Go live in just 3 days with our pre-tested, white-label setup.",
  },
  {
    id: "5",
    question: "06. Can Mobility Infotech’s app integrate with existing business systems?",
    answer: "Yes, including Brazilian payment systems like Pix and CRM/ERP software.",
  },
  {
    id: "6",
    question: "07. What advanced technologies does Mobility Infotech use in its 99Taxis Clone App?",
    answer: "AI, AR, IoT, Blockchain, and multilingual chatbot systems—all built in.",
  },
  {
    id: "7",
    question: "08. How does Mobility Infotech ensure the security of the app?",
    answer: "We use encryption, secure APIs, and blockchain for tamper-proof transactions.",
  },
];

export default function Taxis99() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
